import React from 'react'
import classNames from 'classnames'
import classes from '@src/styles/WhyDimension.module.css'
import onDemand from '@src/assets/b2b-features/on-demand.svg'
import transparent from '@src/assets/b2b-features/transparent.svg'
import flexible from '@src/assets/b2b-features/flexible.png'
import satisfaction from '@src/assets/b2b-features/satisfaction.svg'
import dimensionLogo from '@src/assets/dimension-logo-new.svg'
import { MdCheckCircle, MdClose } from 'react-icons/md'
import Link from 'next/link'
import { segmentTrack } from '@src/functions/segment'
import { useRouter } from 'next/router'

function WhyDimension() {
  const router = useRouter();
  const { gclid, keyword } = router.query;
  const handleConsultation = () => {
    segmentTrack('Click', {
      button: 'Book a Consultation',
    })
    if (typeof window !== "undefined") {
      window.open('https://calendly.com/nelson-getdimension/introductory-chat-with-dimension', '_blank');
    }
  }
  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <h2 className={classes.heading}>Why Dimension?</h2>
        <p className={classes.description}>
          Dimension makes it easy for companies of any size to book reliable and accountable waste
          management services online and nationwide
        </p>
        <div className={classes.tableContainer}>
          <div className={classes.fixedColumnTable}>
            <table className={classes.whyDimensionTable}>
              <thead className={classes.tableHeader}>
                <tr>
                  <th className={classes.fixedColumn}>
                    Service
                    <br />
                    Name
                  </th>
                  <th>
                    On
                    <br />
                    Demand
                  </th>
                  <th>
                    Transparent
                    <br />
                    Pricing
                  </th>
                  <th>
                    Flexibility and
                    <br />
                    Accountability
                  </th>
                  <th>
                    Satisfied
                    <br />
                    Customers
                  </th>
                </tr>
              </thead>
              <tbody className={classes.tableBody}>
                <tr>
                  <td className={classes.fixedColumn}>
                    <img src={dimensionLogo.src} alt='Dimension Logo' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                </tr>
                <tr>
                  <td className={classes.fixedColumn}>1-800-GOT-JUNK</td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                </tr>
                <tr>
                  <td className={classes.fixedColumn}>Junk King</td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                </tr>
                <tr>
                  <td className={classes.fixedColumn}>Recology</td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                </tr>
                <tr>
                  <td className={classes.fixedColumn}>Waste Management</td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdCheckCircle color='#DBC6AA' />
                  </td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                  <td>
                    <MdClose color='#89918b' />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className={classes.buttonContainer}>
          <button className={classes.secondaryButton} onClick={() => handleConsultation()}>
            Book a consultation
          </button>
          <Link className={classes.primaryButton} href={`${process.env.NEXT_PUBLIC_REDIRECT_URL}booking?step=initial&gclid=${gclid ?? ""}&keyword=${keyword ?? ""}&redirect=1`}>
            Book now
          </Link>
        </div>
        <div className={classes.featureContainer}>
          <div className={classes.feature}>
            <img alt='on demand' src={onDemand.src} />
            <h2 className={classNames(classes.heading, classes.cardHeading)}>On Demand</h2>
            <p className={classes.description}>
              Get a quote instantly and same-day service every day of the week, 5 am to 8 pm.
            </p>
          </div>
          <div className={classes.feature}>
            <img alt='transparent' src={transparent.src} />
            <h2 className={classNames(classes.heading, classes.cardHeading)}>
              Transparent Pricing
            </h2>
            <p className={classes.description}>
              The price we quote you is the price you’ll pay. No hidden fees, no last minute
              charges, just radically efficient waste removal.
            </p>
          </div>
          <div className={classes.feature}>
            <img alt='flexible' src={flexible.src} />
            <h2 className={classNames(classes.heading, classes.cardHeading)}>
              Flexible and Accountable
            </h2>
            <p className={classes.description}>
              Whether it&apos;s a bespoke solution that&apos;s tailor-made for you or waste
              diversion data to ensure compliance, Dimension takes all the trouble out of waste
              management.
            </p>
          </div>
          <div className={classes.feature}>
            <img alt='satisfaction' src={satisfaction.src} />
            <h2 className={classNames(classes.heading, classes.cardHeading)}>
              Satisfaction Guaranteed
            </h2>
            <p className={classes.description}>
              Nothing matters to us more than our customers. Everyone at Dimension, from our
              providers to our ever-helpful support team is here to service your needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhyDimension
